"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Env = void 0;
exports.getEnvironment = getEnvironment;
var _getHostname = require("./getHostname");
var Env = exports.Env = /*#__PURE__*/function (Env) {
  Env["PROD"] = "production";
  Env["DEV"] = "development";
  Env["LOCAL"] = "local";
  Env["TEST"] = "test";
  return Env;
}({});
function getEnvironment() {
  var hostName = (0, _getHostname.getHostname)();
  var domainParts = hostName.split('.');
  var godaddyDomain = domainParts.reverse()[1];
  if (!godaddyDomain) return Env.LOCAL;
  var envDomainSplit = godaddyDomain.split('-');
  if (envDomainSplit.length === 1) return Env.PROD;
  if (envDomainSplit[0] === 'dev') return Env.DEV;
  if (envDomainSplit[0] === 'test') return Env.TEST;
  return Env.LOCAL;
}